export const getPrice = (price?: number, reduc?: number) => {
  return (
    (reduc
      ? ((price ?? 0) * (1 - Number(reduc ?? 0) / 100)).toFixed(2)
      : price) ?? 0
  );
};

export const displayPriceProduct = (price: number, reduction: number) =>
  Number(getPrice(price, reduction)).toFixed(2).replace(".", ",");

export const displayNumber = (price: number) =>
  price.toFixed(2).replace(".", ",");
